import {
  DefaultConfigBuilderContext,
  PresentationType,
  SectionViewBuilderContext,
  SectionWidget,
  ShouldFetchDataResolverContext,
} from "../section-widget";
import { HeaderBrandingSectionConfig } from "./header-branding-section-config";
import { HeaderBrandingSectionView } from "./header-branding-section-view";
import { getDaysOnMarket } from "../../shared/get-days-on-market";
import { v4 as uuidv4 } from "uuid";
import { HeaderBrandingSectionData } from "./header-branding-section-data";

type SectionType = "header-branding";

export class HeaderBrandingSectionWidget
  implements
    SectionWidget<
      SectionType,
      HeaderBrandingSectionConfig,
      HeaderBrandingSectionView
    >
{
  type: SectionType = "header-branding";

  supportedPresentationTypes: PresentationType[] = ["cma"];

  buildDefaultConfig(
    _: DefaultConfigBuilderContext
  ): HeaderBrandingSectionConfig {
    return {
      type: "header-branding",
      navTitle: "Header",
      id: uuidv4(),
      visibility: true,
      showDaysOnMarket: true,
      showClientName: true,
      showPresentationTitle: true,
      showPriceRange: false,
      officeLogo: undefined,
      shouldFetchFromUserProfile: true,
    };
  }

  buildView({
    sectionConfig: config,
    sectionData: data,
    context,
  }: SectionViewBuilderContext<
    HeaderBrandingSectionConfig,
    HeaderBrandingSectionData
  >): HeaderBrandingSectionView {
    if (config.type !== "header-branding")
      throw new Error("Unexpected section type.");
    const {
      priceRange,
      featuredProperty,
      clientDisplayName,
      presentationName,
    } = context.sourceData;
    const {
      id,
      type,
      visibility,
      showDaysOnMarket = true,
      showClientName = true,
      showPresentationTitle = true,
      officeLogo = data?.officeLogo || null,
    } = config;
    let {
      showPriceRange = !(priceRange.min == null && priceRange.max == null),
    } = config;
    if (!context.editMode && priceRange.min == null && priceRange.max == null) {
      showPriceRange = false;
    }

    const view: HeaderBrandingSectionView = {
      id,
      presentationName,
      type,
      navTitle: "Header",
      visibility,
      addressLine1: featuredProperty.addressLine1 ?? "No address",
      addressLine2: featuredProperty.addressLine2 ?? "",
      clientName: clientDisplayName,
      propertyPhoto: featuredProperty.photos && featuredProperty.photos[0]?.url,
      maxSellPrice: priceRange.max,
      minSellPrice: priceRange.min,
      zipCode: featuredProperty.zipCode ?? "-",
      photos: featuredProperty.photos,
      daysOnMarket: getDaysOnMarket(
        featuredProperty.listDate,
        featuredProperty.soldDate
      ),
      state: featuredProperty.state ?? "-",
      city: featuredProperty.city ?? "-",
      officeLogo,
      preferences: {
        showPriceRange,
        showDaysOnMarket,
        showClientName,
        showPresentationTitle,
      },
    };
    return view;
  }

  shouldInvalidateData(
    _: ShouldFetchDataResolverContext<
      HeaderBrandingSectionConfig,
      HeaderBrandingSectionData
    >
  ): boolean {
    return false;
  }

  canFetchData({ config }: { config: HeaderBrandingSectionConfig }) {
    return Boolean(config.shouldFetchFromUserProfile);
  }
}
